import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';
import './QuestionDetail.css';

const QuestionDetail = () => {
  const { questionId } = useParams();
  const { user } = useAuth();
  const [question, setQuestion] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newAnswer, setNewAnswer] = useState('');

  useEffect(() => {
    fetchQuestion();
  }, [questionId]);

  const fetchQuestion = async () => {
    try {
      const response = await api.get(`/forums/questions/${questionId}`);
      setQuestion(response.data.question);
      setAnswers(response.data.answers);
    } catch (error) {
      console.error('Error fetching question:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitAnswer = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/forums/questions/${questionId}/answer`, { content: newAnswer });
      setNewAnswer('');
      fetchQuestion();
    } catch (error) {
      console.error('Error posting answer:', error);
    }
  };

  const handleAcceptAnswer = async (answerId) => {
    try {
      await api.put(`/forums/answers/${answerId}/accept`);
      fetchQuestion();
    } catch (error) {
      console.error('Error accepting answer:', error);
    }
  };

  const handleUpvote = async (answerId) => {
    try {
      await api.post(`/forums/answers/${answerId}/upvote`);
      fetchQuestion();
    } catch (error) {
      console.error('Error upvoting:', error);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (!question) return <div className="page">Question not found</div>;

  return (
    <div className="page question-detail-page">
      <div className="container">
        <div className="question-detail-card">
          <h1>{question.title}</h1>
          <div className="question-body">
            <p>{question.content}</p>
          </div>
          <div className="question-footer">
            <span className="author">
              Asked by {question.first_name} {question.last_name}
            </span>
            <span className="date">
              {new Date(question.created_at).toLocaleDateString()}
            </span>
            <span className="views">{question.views} views</span>
          </div>
        </div>

        <div className="answers-section">
          <h2>{answers.length} Answers</h2>

          {answers.map(answer => (
            <div key={answer.id} className={`answer-card ${answer.is_accepted ? 'accepted' : ''}`}>
              <div className="answer-votes">
                <button onClick={() => handleUpvote(answer.id)} className="upvote-btn">
                  ▲
                </button>
                <span className="vote-count">{answer.upvotes}</span>
                {answer.is_accepted && (
                  <span className="accepted-check">✓</span>
                )}
              </div>
              <div className="answer-content">
                <p>{answer.content}</p>
                <div className="answer-footer">
                  <span className="author">
                    {answer.first_name} {answer.last_name}
                    {answer.role === 'instructor' && (
                      <span className="instructor-badge">Instructor</span>
                    )}
                  </span>
                  <span className="date">
                    {new Date(answer.created_at).toLocaleDateString()}
                  </span>
                  {user && (user.id === question.user_id || user.role === 'instructor' || user.role === 'admin') && !answer.is_accepted && (
                    <button
                      onClick={() => handleAcceptAnswer(answer.id)}
                      className="accept-btn"
                    >
                      Accept Answer
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {user ? (
          <div className="answer-form-card">
            <h3>Your Answer</h3>
            <form onSubmit={handleSubmitAnswer}>
              <textarea
                value={newAnswer}
                onChange={(e) => setNewAnswer(e.target.value)}
                placeholder="Write your answer here..."
                rows="5"
                required
              />
              <button type="submit" className="btn-primary">
                Post Answer
              </button>
            </form>
          </div>
        ) : (
          <div className="login-prompt">
            <p>Please log in to answer this question.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionDetail;
